export const CREATE_BASKET = "basket/CREATE_BASKET";
export const ADD_ITEM_TO_BASKET = "basket/ADD_ITEM";
export const REMOVE_ITEM_FROM_BASKET = "basket/REMOVE_ITEM";
export const CLEAR_BASKET = "basket/CLEAR_BASKET";

export const BASKET_SYNC_ITEM = "basket/SYNC/ITEM";
export const BASKET_SYNCED_ITEM = "basket/SYNC/ITEM_SYNCED";
export const BASKET_SYNC_FAILED_ITEM = "basket/SYNC/ITEM_FAILED";
